import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { selectUser } from '../../../../state/auth/auth.selectors';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { BASE } from '../../../../../configs/routes.config';

@Component({
  selector: 'wil-verify-email-page',
  standalone: true,
  imports: [MatIcon, AsyncPipe, TranslatePipe],
  templateUrl: './verify-email-page.component.html',
  styleUrl: './verify-email-page.component.scss',
})
export class VerifyEmailPageComponent {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  public readonly email$ = this.store.select(selectUser).pipe(map((user) => user?.email));

  public navigateToProfile(): void {
    this.router.navigate([`/${BASE}/account/profile`]);
  }
}
